import { luaReceived, setUserCustomLuas, LuaPayload } from '.'
import _ from 'lodash'
import { getShowChannel } from 'redux/slices/interaction'
import { getShowPassList } from 'redux/slices/passes'
import { getLUAAsset } from 'api/api'
import { AppThunk } from 'redux/store'
import { AnyObject } from 'data/Common'
import { User } from 'data/User'
import { LuaPassTier } from 'data/Show'
import moment from 'moment'
import * as safeApi from 'api'

let enqueuedLua: LuaPayload | AnyObject = {}

const enqueueLua = (lua: LuaPayload, user: User) => {
    if (!_.get(user, 'country.emoji') || _.get(user, 'country.emoji') !== enqueuedLua.emoji) {
        enqueuedLua = lua
    }
}

const sendEnqueuedLua = async (showId: string) => {
    safeApi.postLUA(
        {
            showId,
            emoji: enqueuedLua.emoji,
            timestamp: moment().toISOString(),
            isUnicode: enqueuedLua.isUnicode,
        },
        { withCredentials: false },
    )
    enqueuedLua = {}
}

const throttledSendLua = _.throttle(sendEnqueuedLua, 5000)

export const sendLUA = (showId: string, lua: LuaPayload, user: User): AppThunk => async (dispatch, getState) => {
    try {
        dispatch(luaReceived(lua))
        enqueueLua(lua, user)
        await throttledSendLua(showId, getShowChannel(getState()))
    } catch (err) {
        console.error('LUA not sent', err)
    }
}

const preloadSvg = (url: string, rawSvg: string) => {
    const wrapper = document.createElement('div')

    wrapper.innerHTML = rawSvg

    const svg = wrapper.firstElementChild as SVGElement

    const symbol = document.createElementNS('http://www.w3.org/2000/svg', 'symbol')

    const viewBox = svg.getAttribute('viewBox')!

    symbol.setAttribute('viewBox', viewBox)
    symbol.setAttribute('id', url)

    // @ts-ignore
    const children = [...svg.children]

    svg.appendChild(symbol)

    children.forEach(child => {
        child.remove()
        symbol.appendChild(child)
    })

    document.head.append(svg)

    return url
}

export const retrieveUserCustomLuas = (luaPassTiers: LuaPassTier[], showId: string): AppThunk => async (
    dispatch,
    getState,
) => {
    luaPassTiers.forEach(async tier => {
        const response = await getLUAAsset(tier.imgUrl).catch(() => null)

        if (response) {
            preloadSvg(response.imgUrl, response.svg)
        }
    })

    // eslint-disable-next-line
    function setCustomLuas(luas: LuaPassTier[]) {
        const jct = luaPassTiers.map(luaPassTier => ({
            luaPassTierId: luaPassTier._id,
            luaPassTierImgUrl: luaPassTier.imgUrl,
        }))

        if (jct.length) {
            dispatch(setUserCustomLuas(jct))
        }
    }

    const passes = getShowPassList(getState())

    if (passes?.some(pass => pass.promoCode && pass.show === showId)) {
        setCustomLuas(luaPassTiers)
    } else {
        //Get all pass tiers that this user purchased for this show
        const passListTiers = passes.filter(pass => pass.show === showId).map(pass => pass.passTier)

        //Find all pass tiers that this user purchased that also have a custom LUA
        setCustomLuas(luaPassTiers.filter(luaPassTier => _.intersection(passListTiers, luaPassTier.passTiers).length))
    }
}
